const PREFERENCE_STORAGE_PREFIX = 'focus-user-preference';

/**
 * Reads a single remembered user preference (e.g. a heatmap transparency
 * setting) from localStorage. Single shared location for every "remember
 * this choice" read across the app - see also setStoredPreference(). Keep
 * every persisted-preference read routed through this one function rather
 * than re-deriving the storage key/parsing per call site.
 * @param {string} key
 * @param {*} fallback - returned if nothing is stored yet, or on any read error.
 * @returns {*}
 */
const getStoredPreference = (key, fallback) => {
  if (typeof window === 'undefined' || !window.localStorage) return fallback;
  try {
    const raw = window.localStorage.getItem(
      `${PREFERENCE_STORAGE_PREFIX}:${key}`
    );
    if (raw === null) return fallback;
    return JSON.parse(raw);
  } catch (error) {
    return fallback;
  }
};

/**
 * Persists a single user preference to localStorage so it survives reloads.
 * Silently no-ops on write failure (quota exceeded, private browsing) -
 * preferences are a nice-to-have, never something that should break the app.
 * @param {string} key
 * @param {*} value
 */
const setStoredPreference = (key, value) => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(
      `${PREFERENCE_STORAGE_PREFIX}:${key}`,
      JSON.stringify(value)
    );
  } catch (error) {
    // Ignore - keep app functional even if storage is unavailable/full.
  }
};

export { getStoredPreference, setStoredPreference };
